export default class BrowserCtrl {
    constructor($scope, $timeout, Events, $filter) {
        this._scope = $scope;
        this._filter = $filter;
        this._translator = $filter('translate');
        this._timeout = $timeout;

        this.eventHandler = Events;

        this.panelVisible = false;
        
        this._scope.$on('browser:getContentTables', () => {
            this._timeout(() => {
                this._scope.$broadcast('browser:editor:getContentTables');
            }, 500);
        });

        this._scope.$on('browser:editor:tablesFetched', (event, contentTables) => {
            this._scope.$broadcast('browser:resizer:insert', contentTables);    
        });

        this._scope.$on('browser:panel:applyLineHeight', (event, newHeight) => {
            this._scope.$broadcast('browser:editor:applyLineHeight', newHeight);
        });
        
        this._scope.$on('browser:panel:fontChanged', (event, font) => {
            this._scope.$broadcast('browser:editor:applyFont', font);
        });

        this._scope.$on('browser:panel:colorChanged', (event, color) => {
            this._scope.$broadcast('browser:editor:applyFontColor', color);
        });

        this._scope.$on('browser:panel:backgroundColorChanged', (event, color) => {
            this._scope.$broadcast('browser:editor:applyBackground', color);
        });
        
        this._scope.$on('browser:panel:setFontSize', (event, newSize) => {
            this._scope.$broadcast('browser:editor:applyFontSize', newSize);
        });
        
        this._scope.$on('browser:panel:imageSettingsChanged', (event, showImages) => {
            this._scope.$broadcast('browser:editor:applyImageSettings', showImages);
        });
        
        this._scope.$on('browser:panel:paragraphLengthChanged', (event, showLess) => {
            this._scope.$broadcast('browser:editor:applyParagraphLengthSetting', showLess);
        });
    }

    toggleVisible() {
        this.panelVisible = ! this.panelVisible;
    }

    getEvents() {
        return this.eventHandler.getEvents();
    }

    hasEvents() {
        return this.eventHandler.hasEvents();
    }
}
